import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataServiceService } from '../service/data-service.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  basicData: any;
  display=false
  sidebarExpanded = true;
  basicOptions: any;
  baseAppName: string = environment.baseAppName;
  srcsetwebp1: string = "/" + this.baseAppName + "/assets/img/avatar/avatar-illustrated-01.webp";
  imgsrc1: string = "/" + this.baseAppName + "/assets/img/avatar/avatar-illustrated-01.png";
  srcsetwebp2: string = "/" + this.baseAppName + "/assets/img/avatar/avatar-illustrated-02.webp";
  imgsrc2: string = "/" + this.baseAppName + "/assets/img/avatar/avatar-illustrated-02.png";

  multiAxisData: any;

  chartOptions: any;

  multiAxisOptions: any;

  stackedData: any;

  stackedOptions: any;

  horizontalOptions: any;

  menuItem : any [] = [];
username=localStorage.getItem('DeptName')
  
  constructor(private router: Router, private  dataService:DataServiceService) { }

  ngOnInit(): void {
    console.log(this.dataService.menuRightsList);
    const menu = JSON.parse(localStorage.getItem('Menu') || '[]');
    //this.menuItem = this.dataService.menuRightsList;
    this.menuItem = menu;
  }
  chagesidebar(){
if(this.display==false){
  this.display=true
}else{
  this.display=false
}
  }
  logout(){
    localStorage.clear()
    this.router.navigate(['/login']);
  }

  getCurrentUrl(){
    const currentUrl = this.router.url;
    //console.log(currentUrl);
  }

  // ngAfterViewInit(){
  //   const cUrl = this.router.url;
  //   console.log(cUrl);
  // }
}
